import * as React from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import { useTranslation } from "react-i18next";

type AudioPopoverProps = {
    audioUrl: string;
    label?: string;
    only_view?: boolean;
};

const AudioPopover: React.FC<AudioPopoverProps> = ({ audioUrl, only_view, label }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const id = open ? "audio-popover" : undefined;

    const audioRef = React.useRef<HTMLAudioElement | null>(null);

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // หยุดเสียงเมื่อปิด
    React.useEffect(() => {
        if (!open && audioRef.current) {
            audioRef.current.pause();
        }
    }, [open]);

    return (
        <>
            <IconButton
                aria-describedby={id}
                onClick={only_view ? undefined : handleClick}
                className="bg-white/80 shadow-md hover:bg-white"
            >
                <HeadphonesIcon className="text-gray-800" />
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{
                    className: "rounded-2xl shadow-xl p-4 w-[300px] bg-white",
                }}
            >
                <Box className="flex flex-col gap-2">
                    <Typography variant="subtitle1" className="font-semibold">
                        {label ?? t("เสียง")}
                    </Typography>
                    <audio ref={audioRef} src={audioUrl} controls preload="none" className="w-full" />
                </Box>
            </Popover>
        </>
    );
};

export default AudioPopover;
